import { FC, useEffect } from 'react';
import { SeriesScores } from '../../../../config/api/models/Score';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import {
  setIsFetching,
  setIsOutdated,
  setNoResultsFound,
} from 'src/modules/shared/slices/filters/entity/FiltersSlice';
import { useGetPageScoreQuery } from 'src/modules/shared/slices/score-progress/score';
import { StudentFiltersEnum } from 'src/modules/shared/constants';

type Props = {
  pageId: string;
  onChange: (value?: Record<string, SeriesScores>) => void;
  shouldReFetch: boolean;
};

const UserTrajectoryScoresHandler: FC<Props> = ({
  pageId,
  onChange,
  shouldReFetch,
}) => {
  const dispatch = useAppDispatch();
  const activeFilter = useAppSelector((state) => state.filters.activeFilter);
  const refresh = useAppSelector((state) => state.filters.refresh);

  const {
    data: getTrajectoryScoresByUserResponse,
    isError: getTrajectoryScoresByUserError,
    isSuccess: getTrajectoryScoresByUserSuccess,
    refetch: refetchTrajectoryScoresByUser,
    isLoading: reFetchInProgress
  } = useGetPageScoreQuery({pageId}, {skip: activeFilter !== StudentFiltersEnum.PROGRESS_AND_SCORES});

  useEffect(() => {
    if (getTrajectoryScoresByUserError) {
      dispatch(setNoResultsFound(true));
      onChange();
    }
  }, [getTrajectoryScoresByUserError, onChange, dispatch]);

  useEffect(() => {
    if (getTrajectoryScoresByUserSuccess) {
      if (getTrajectoryScoresByUserResponse) {
        onChange(getTrajectoryScoresByUserResponse.results);
        dispatch(setNoResultsFound(false));
        dispatch(setIsOutdated(getTrajectoryScoresByUserResponse.isOutdated));
      } else {
        dispatch(setNoResultsFound(true));
      }
    }
  }, [
    getTrajectoryScoresByUserResponse,
    getTrajectoryScoresByUserSuccess,
    onChange,
    dispatch,
  ]);

  useEffect(() => {
    if (!reFetchInProgress && (shouldReFetch || (refresh || activeFilter === StudentFiltersEnum.PROGRESS_AND_SCORES))) {
      refetchTrajectoryScoresByUser();
    }
  }, [
    shouldReFetch,
    reFetchInProgress,
    refetchTrajectoryScoresByUser,
    refresh,
    activeFilter
  ]);

  useEffect(() => {
    dispatch(setIsFetching(reFetchInProgress));
  }, [reFetchInProgress, dispatch]);

  return null;
};

export default UserTrajectoryScoresHandler;
